import { inject, makeStateKey, TransferState } from "@angular/core";
import { switchMap } from "rxjs/operators";
import { forkJoin, of } from "rxjs";
import { BookModel } from "@shared/model/bookModels/book-model";
import { TServiceResult } from "@shared/helper/t-service-result";
import { ResolveFn } from "@angular/router";
import { BookService } from "@shared/service/http_services/book.service";
import { ReviewAggrigatorModel } from "@shared/model/review-aggrigator-model";
import { ReviewsAggrigatorService } from "../services/reviewsAggrigator.service";
import { LocalRepository } from "@shared/helper/local-repository";

export const STATE_KEY_REVIEW = makeStateKey<ReviewResolverData>('Review_Resolver_Data');


export const ReviewDetailResolver: ResolveFn<ReviewResolverData> = (route) => {
    const serverState: TransferState = inject(TransferState);
    const bookService: BookService = inject(BookService);
    const _localRepository: LocalRepository = inject(LocalRepository);
    const reviewsAggrigatorService: ReviewsAggrigatorService = inject(ReviewsAggrigatorService);
    if (!_localRepository.IsInBrowser) {
        return reviewsAggrigatorService.getReviewById(route.paramMap.get('id')!)
            .pipe(
                switchMap(reviewData =>
                    forkJoin({
                        review: reviewData != undefined ? of(reviewData) : of(new TServiceResult<ReviewAggrigatorModel>(new ReviewAggrigatorModel(), '', null, true, '')),
                        book: bookService.getBookById(reviewData?.result?.review?.data?.bookId!)
                    })
                ),
                switchMap(forkedData => {
                    const rrd = ReviewResolverData.instance(forkedData);
                    serverState.set(STATE_KEY_REVIEW, rrd);
                    return of(forkedData as ReviewResolverData);
                })
            );
    }
    else {
        serverState.get(STATE_KEY_REVIEW, ReviewResolverData.instanceAllError());
        return of({} as ReviewResolverData);
    }
}


export class ReviewResolverData {
    review!: TServiceResult<ReviewAggrigatorModel>;
    book!: TServiceResult<BookModel>;

    public static instance(rrd: any): ReviewResolverData {
        const data = new ReviewResolverData();
        data.review = rrd.review?.hasError == true ? new TServiceResult<ReviewAggrigatorModel>(new ReviewAggrigatorModel(), '', null, true, '') : rrd.review;
        data.book = rrd.book?.hasError == true ? new TServiceResult<BookModel>(new BookModel(), '', null, true, '') : rrd.book;
        return data;
    }

    public static instanceAllError(): ReviewResolverData {
        const data = new ReviewResolverData();
        data.book = new TServiceResult<BookModel>(new BookModel(), '', null, true, '');
        data.review = new TServiceResult<ReviewAggrigatorModel>(new ReviewAggrigatorModel(), '', null, true, '');
        return data;
    }
}